<template>
  <router-view />
</template>

<script lang="ts" setup>
  console.log('my config env: ', import.meta.env);
</script>
